import menuPhotos, { juicePhotos, productComposerPhotos } from '../assets/menuImages';
import { packs } from './packsData';

export const naturalJuices = [
  {
    id: 'jus-baobab',
    name: 'Jus de Baobab',
    desc: '100% naturel — 33 cl',
    price: 1000,
  },
  {
    id: 'jus-bissap',
    name: 'Jus de Bissap',
    desc: '100% naturel — 33 cl',
    price: 1000,
  },
  {
    id: 'jus-corossol',
    name: 'Jus de Corossol',
    desc: '100% naturel — 33 cl',
    price: 1000,
  },
  {
    id: 'jus-goyave',
    name: 'Jus de Goyave',
    desc: '100% naturel — 33 cl',
    price: 1000,
  },
  {
    id: 'jus-mangue',
    name: 'Jus de Mangue',
    desc: '100% naturel — 33 cl',
    price: 1000,
  },
  {
    id: 'jus-ananas',
    name: 'Jus d\'Ananas',
    desc: '100% naturel — 33 cl',
    price: 1000,
  },
];

const sharedExtras = {
  burgers: [
    { id: 'bacon', name: 'Bacon', price: 500 },
    { id: 'double-steak', name: 'Steak supplémentaire', price: 800 },
    { id: 'extra-cheddar', name: 'Cheddar supplémentaire', price: 300 },
    { id: 'oeuf', name: 'Œuf', price: 300 },
    { id: 'avocat', name: 'Avocat', price: 400 },
  ],
  tacos: [
    { id: 'extra-viande', name: 'Viande supplémentaire', price: 700 },
    { id: 'extra-frites', name: 'Frites supplémentaires', price: 300 },
    { id: 'extra-fromage', name: 'Fromage supplémentaire', price: 300 },
    { id: 'jalapenos', name: 'Jalapeños', price: 200 },
  ],
  crepes: [
    { id: 'nutella-extra', name: 'Nutella supplémentaire', price: 300 },
    { id: 'banane', name: 'Banane', price: 200 },
    { id: 'fraise', name: 'Fraise', price: 250 },
    { id: 'chantilly', name: 'Chantilly', price: 200 },
    { id: 'glace-vanille', name: 'Glace vanille', price: 300 },
  ],
};

export const menuItems = [
  {
    id: 'dowhile-burger',
    name: 'DoWhile Burger',
    desc: 'Double steak, cheddar, salade, tomate, sauce maison',
    basePrice: 1500,
    image: productComposerPhotos['dowhile-burger'] || menuPhotos.burgers,
    category: 'burgers',
    includedIngredients: [
      { id: 'steak', name: 'Double steak' },
      { id: 'cheddar', name: 'Cheddar' },
      { id: 'salade', name: 'Salade' },
      { id: 'tomate', name: 'Tomate' },
      { id: 'sauce-maison', name: 'Sauce maison' },
    ],
    extraIngredients: sharedExtras.burgers,
  },
  {
    id: 'chicken-burger',
    name: 'Chicken Burger',
    desc: 'Poulet croustillant, coleslaw, cornichons',
    basePrice: 1500,
    image: productComposerPhotos['chicken-burger'] || menuPhotos.burgers,
    category: 'burgers',
    includedIngredients: [
      { id: 'poulet', name: 'Poulet croustillant' },
      { id: 'coleslaw', name: 'Coleslaw' },
      { id: 'cornichons', name: 'Cornichons' },
      { id: 'sauce-blanche', name: 'Sauce blanche' },
    ],
    extraIngredients: sharedExtras.burgers,
  },
  {
    id: 'tacos-xxl',
    name: 'Tacos XXL',
    desc: 'Bœuf, frites, sauce fromagère, légumes',
    basePrice: 2000,
    image: productComposerPhotos['tacos-xxl'] || menuPhotos.tacos,
    category: 'tacos',
    includedIngredients: [
      { id: 'boeuf', name: 'Bœuf' },
      { id: 'frites', name: 'Frites' },
      { id: 'sauce-fromagere', name: 'Sauce fromagère' },
      { id: 'legumes', name: 'Légumes' },
    ],
    extraIngredients: sharedExtras.tacos,
  },
  {
    id: 'tacos-poulet',
    name: 'Tacos Poulet',
    desc: 'Poulet grillé, légumes, sauce blanche',
    basePrice: 2000,
    image: productComposerPhotos['tacos-poulet'] || menuPhotos.tacos,
    category: 'tacos',
    includedIngredients: [
      { id: 'poulet-grille', name: 'Poulet grillé' },
      { id: 'legumes', name: 'Légumes' },
      { id: 'sauce-blanche', name: 'Sauce blanche' },
    ],
    extraIngredients: sharedExtras.tacos,
  },
  {
    id: 'crepe-nutella',
    name: 'Crêpe Nutella',
    desc: 'Banane, fraise, Nutella, chantilly',
    basePrice: 1500,
    image: productComposerPhotos['crepe-nutella'] || menuPhotos.crepes,
    category: 'crepes',
    includedIngredients: [
      { id: 'nutella', name: 'Nutella' },
      { id: 'banane', name: 'Banane' },
      { id: 'fraise', name: 'Fraise' },
      { id: 'chantilly', name: 'Chantilly' },
    ],
    extraIngredients: sharedExtras.crepes,
  },
  {
    id: 'crepe-salee',
    name: 'Crêpe Salée',
    desc: 'Jambon, fromage, œuf, champignons',
    basePrice: 2000,
    image: productComposerPhotos['crepe-salee'] || menuPhotos.crepes,
    category: 'crepes',
    includedIngredients: [
      { id: 'jambon', name: 'Jambon' },
      { id: 'fromage', name: 'Fromage' },
      { id: 'oeuf', name: 'Œuf' },
      { id: 'champignons', name: 'Champignons' },
    ],
    extraIngredients: [
      { id: 'emmental', name: 'Emmental supplémentaire', price: 300 },
      { id: 'jambon-extra', name: 'Jambon supplémentaire', price: 400 },
      { id: 'oeuf-extra', name: 'Œuf supplémentaire', price: 300 },
    ],
  },
  ...packs.map(({ emoji, tagline, highlight, ...pack }) => pack),
  ...naturalJuices.map((juice) => ({
    id: juice.id,
    name: juice.name,
    desc: `${juice.desc} — sans conservateur, sans colorant`,
    basePrice: juice.price,
    image: juicePhotos[juice.id] || menuPhotos.jusNaturels,
    category: 'boissons',
    isNaturalJuice: true,
    includedIngredients: [
      { id: 'naturel', name: '100% fruits naturels' },
      { id: 'volume', name: 'Bouteille 33 cl' },
    ],
    extraIngredients: [],
  })),
];

export const menuCategories = [
  { id: 'all', label: 'Tout' },
  { id: 'packs', label: '🎁 Packs' },
  { id: 'burgers', label: '🍔 Burgers' },
  { id: 'tacos', label: '🌮 Tacos' },
  { id: 'crepes', label: '🥞 Crêpes' },
  { id: 'boissons', label: '🥤 Boissons' },
];
